function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
  fill: "#FFFBCC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4687 5.80696L4.90624 16.2195C4.85224 16.3252 4.82656 16.4432 4.8317 16.5618C4.83684 16.6805 4.87262 16.7958 4.93556 16.8965C4.9985 16.9972 5.08645 17.0798 5.19084 17.1364C5.29523 17.1931 5.41251 17.2217 5.53124 17.2195H18.3125C18.4532 17.22 18.5917 17.1844 18.7145 17.1159C18.8374 17.0474 18.9406 16.9484 19.0141 16.8284C19.0876 16.7084 19.1289 16.5715 19.1341 16.4309C19.1393 16.2903 19.1082 16.1508 19.0437 16.0257L12.5375 5.80696C12.4818 5.71512 12.4033 5.63919 12.3097 5.58649C12.2161 5.53379 12.1105 5.5061 12.0031 5.5061C11.8957 5.5061 11.7901 5.53379 11.6965 5.58649C11.6029 5.63919 11.5245 5.71512 11.4687 5.80696Z",
  fill: "#865000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.64777V13.3978M12 15.1251V15.0751",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4688 14.9688C12.4688 15.2276 12.2589 15.4375 12 15.4375C11.7411 15.4375 11.5312 15.2276 11.5312 14.9688C11.5312 14.7099 11.7411 14.5 12 14.5C12.2589 14.5 12.4688 14.7099 12.4688 14.9688Z",
  fill: "white"
});

function SvgStepUnscheduled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepUnscheduled);
export default __webpack_public_path__ + "static/media/step-unscheduled.edda5bcc.svg";
export { ForwardRef as ReactComponent };